<div
  cdkDropList
  [cdkDropListDisabled]="orderDisabled"
  class="drag-and-drop-list container"
  (cdkDropListDropped)="dropItem($event)"
  cdkDropListLockAxis="y"
  #list>
  @for (option of allOptions; track option) {
    <div
      cdkDrag
      class="row drag-and-drop-item"
      [class.new-option]="isNewOption(option)"
      [cdkDragBoundary]="list">
      @if (!orderDisabled) {
        <div class="col-auto pe-0" cdkDragHandle>
          <i class="far fa-bars reorder-icon"></i>
        </div>
      }
      <div class="col" cdkDragHandle>
        {{ isUserType ? option.user.displayName : option.value }}
      </div>
      @if (!option.isLocked) {
        <div
          class="col-auto remove-icon"
          (click)="removeOption(option)"
          ngbTooltip="Remove option"
          container="body">
          <i class="far fa-times"></i>
        </div>
      }
      @if (option.isLocked) {
        <div class="col-auto lock-icon" ngbTooltip="Option cannot be removed" container="body">
          <i class="far fa-lock-alt"></i>
        </div>
      }
    </div>
  }
</div>
